import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DebQuestionCard = styled(Card)(({ theme }) => ({
    width: "90%", 
    boxShadow: '2px 4px 6px 1px rgba(0,0,0,0.3)',
    margin: "1rem 0 !important"
}));